import API from '../http'
import {IsManagerPro} from '@/utils'

/**
 * 获取应用信息
 * @param params
 * @returns
 */
export const AppList = (params: any) => {
  if (IsManagerPro) {
    return API.GET('/itg/admin/appInfo/list', params)
  }
  return API.GET('/itg/appInfo/client/list', params)
}

/**
 * 获取环境信息
 * @param params
 * @returns
 */
export const EnvList = (params: any) => {
  const prefix = IsManagerPro ? '/itg/admin/appInfo' : '/itg/appInfo/client'
  return API.GET(`${prefix}/appEnv/${params.appType}`, params)
}


/**
 * 上传
 * @param params
 * @returns
 */
export const Upload = (params: any) => {
  return API.POST('/joe/admin/media/upload', params)
}

